export {
  default as gameRoom,
  ReactComponent as GameRoom,
} from '@assets/icons/features-and-amenities/game-room.svg'    
